import { Component, OnInit } from '@angular/core';

import { NotifyService } from '../shared/services/notify.service';

import { INotification } from '../shared/interfaces/notification';

@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.css']
})
export class NotifyComponent implements OnInit {

  notifications: INotification[] = [];

  constructor(private _notifyService: NotifyService) {
    this._notifyService.note$.subscribe(
      note => {
        this.notifications.push(note);
        setTimeout(this.clearNote, 3000, this.notifications);
      }
    )
   }

  ngOnInit() {
  }

  clearNote(notes) {
    notes.splice(0,1);
  }

  remove(i: number) {
    this.notifications.splice(i, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/notify/notify.component.ts